import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoRede } from '../../servicos/srv.rede';

@Component({
  selector: 'tsv2-rde-adicionar',
  templateUrl: './adicionar.component.html',
  providers: [ ServicoMsg, ServicoRede ]
})
export class RedeAdicionarComponent implements OnInit {
  exibirBarra: boolean = true;

  psq: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoRede: ServicoRede
  ) { }

  ngOnInit() {
  }

  adicionarRede(frmValues){
    // this.spinner.show();
    this.servicoRede.adicionarRede(frmValues).subscribe(id => {
      let url = '/rede/visualizar/' + id;
      // this.spinner.hide();
      this.servicoMsg.exibeSucesso('Criada!', 'Rede criada com sucesso!').then(r1 => {
        if (r1.success){
          this.router.navigate([url]);
        }
      }, (err: any) => {
        // this.spinner.hide();
        this.servicoMsg.exibeErro(err).then(r1 => {});
      });
    }, (err: any) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
